<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    title="选择技能"
    width="800px"
    top="5vh"
  >
    <TableSelect :filter="filter" ref="tableSelect" :columns="columns" module="basic" url="skills" @select="selectSkills" @reset="resetHandle">
      <template slot="adSearch">
        <el-form :inline="true" ref="form" :model="filter">
          <el-form-item label="技能编号" prop="skillNo">
            <el-input v-model.trim="filter.skillNo" placeholder="请输入技能编号" clearable />
          </el-form-item>
          <el-form-item label="技能名称" prop="skillName">
            <el-input v-model.trim="filter.skillName" placeholder="请输入技能名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </TableSelect>
  </el-dialog>
</template>

<script>
import TableSelect from "@/components/TableSelect.vue";

export default {
  components: { TableSelect },
  data() {
    return {
      dialogVisible: false,
      filter: {
        skillNo: "",
        skillName: "",
      },
      columns: [
        {
          title: "技能编号",
          key: "skillNo",
          width: 100,
          align: "center",
        },
        {
          title: "技能名称",
          key: "skillName",
          minWidth: 150,
          tooltip: true,
        },
        {
          title: "操作",
          slot: "action",
          width: 80,
          align: "center",
        },
      ],
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.$refs.tableSelect.loadData();
      });
    },

    selectSkills(row) {
      this.dialogVisible = false;
      this.$emit("select", row);
    },

    resetHandle(filter) {
      this.filter = filter;
    },
  },
};
</script>
